import i18n from "../i18n";
import { createContext, useContext, useEffect, useState } from "react";
import config from "../config";

const tr = (...args) => i18n.t(...args);

// Create Context
const LayoutContext = createContext();

// Provider Component
export const LayoutProvider = ({ children, user }) => {

    const [layoutSrc, setLayoutSrc] = useState(null);

    useEffect(() => {
        const fetchLayout = async () => {
            try {
                const response = await fetch(tr('{{API_BASE_URL}}/_companies/layout', {
                    API_BASE_URL: config.API_BASE_URL
                }));
                if (response.ok) {
                    const blob = await response.blob();
                    setLayoutSrc(URL.createObjectURL(blob));
                } else {
                    console.error("Failed to fetch layout image");
                }
            } catch (error) {
                console.error("Error fetching layout image:", error);
            }
        };
        
        //console.log('user', user)

        if (user && user._company) {
            fetchLayout();
        }
        
    }, [user]);

    return (
        <LayoutContext.Provider value={layoutSrc}>
            {children}
        </LayoutContext.Provider>
    );
};

// Hook to use the Layout Image
export const useLayoutImage = () => {
    return useContext(LayoutContext);
};
